import './App.css';
import {Window, Prompt, PicLink,ScrollReset} from './obj.js'
import advent from './img/advent/Adventposter.webp'
import beginner from './img/beginners/beginners2024.webp'
import mcpc from './img/MCPC/MCPC2024.webp'
import workshop from './img/workshops/workshop-1.webp'
import {ReactComponent as Logo} from "./logo.svg"
import optiver from "./img/optiverLogo.png"
import { Link } from 'react-router-dom';

function Home(){
    return(
        <>
            <div className = "banner">
                <ScrollReset/>
                <div className = "noiseOverlay"></div>
                <div className = "bannerContent">
                    <h1 className = "titleTop">Monash Algorithms</h1>
                    <h1 className = "titleBottom">& Problem Solving</h1>
                    <h4> Competitive Programming team @ Monash</h4>
                    <Link  to = "/discord" target = "_blank" className = "accentButton menuButton" id = "joinButton">Join Maps</Link>
                </div>
                <p><span>Sponsored by</span><img src = {optiver} alt = "Optiver"></img></p>
            </div>
            <main>
                <section className='twocol'>
                    <Logo id = "mottologo" color = "blue"/>
                    <div>
                        <h3 className = "motto">INGENUITY.</h3>
                        <h3 className = "motto">INSIGHT.</h3>
                        <h3 className = "motto">ALGORITHMS.</h3>
                    </div>
                    <Window>
                        <p>MAPS is an IT student team at Monash University which focuses on Competitive Programming.</p>

                        <p>We run weekly workshops and host programming competitions on algorithms and data structures.</p>
                    </Window>
                    
                </section>
                <section>
                    <h3 className = "halfheader">COMPETITIVE PROGRAMMING</h3>
                    <div className = 'twocol'>
                        <div className = "problemWindow">
                            <Window>
                                <p><i>Here is an example of a problem you might face, see if you can solve it <a target = "_blank" href="https://judge.monashaps.com/problem/primecut2" rel = "noreferrer">here</a></i></p>
                                <p className = "dark">## Problem Statement</p>
                                <p>Any integer larger than 1 can be expressed as the sum of 1 or more non-distinct prime numbers.
                                    For a given integer, ~n~, find the minimum number of prime numbers such that their sum is ~n~.</p>
                                <p className = "dark">## Input Format</p>
                                <p>One integer is given, ~n~.<br></br>(1 &lt; n &lt; 1e4)</p>
                                <p className = "dark">## Output Format</p>
                                <p>Output the minimum number of prime numbers which would be required to have ~n~ as their sum.</p>   
                            </Window>
                            
                        </div>
                        <Prompt>In a competitive programming contest, coders need to create
                             short applications that can solve mathematical problems algorithmically. <br></br><br></br>
                            As a competitive programming team, we strive to enhance the skills of our members to bolster their coding abilities.
                        </Prompt>
                    </div>
                </section>
                <section className='twocol'>
                    <div>
                        <h3 className = "halfheader eventTitle">EVENTS</h3>
                        <Prompt>
                            We host events such as workshops, competitions and training sessions, catering to a large variety of skill levels. 
                        </Prompt>
                    </div>
                    <div className = 'twobytwo'>
                        <PicLink src = {advent} target = {"events/advent"}></PicLink>
                        <PicLink src = {mcpc} target = {"events/mcpc"}></PicLink>
                        <PicLink src = {workshop} target = {"events/workshops"}></PicLink>
                        <PicLink src = {beginner} target = {"events/beginner"}></PicLink>
                    </div>
                </section>
                
            </main>
        </>
    );
}

export default Home;